import * as React from 'react';
import { TestProjectInputEditorStore } from '../../stores';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';

type Props = {
    store: TestProjectInputEditorStore;
};

const TestProjectAppInputGroupSelector: React.FC<Props> = ({ store }) => {
    const inputSelectionStore = store.draft?.inputSelectionStore;

    if (!inputSelectionStore) {
        return null;
    }

    if (inputSelectionStore.currentApplicationInputGroups.length === 0) {
        return null;
    }

    return (
        <Select
            disabled={!store.canEdit}
            style={{ width: '235px' }}
            options={inputSelectionStore.currentApplicationInputGroups.map(ig => ({
                title: ig.name,
                label: ig.name,
                value: ig.id
            }))}
            showSearch
            value={inputSelectionStore.selectedInputGroupForBindings || undefined}
            onChange={value => store.changeMappingInputGroup(value)}
            filterOption={(input, option) => option?.title && option.title.toLowerCase().includes(input.toLowerCase())}
            placeholder="Select target input group"
        />
    );
};

export default observer(TestProjectAppInputGroupSelector);
